import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// Icons
import { IoMdMenu } from 'react-icons/io';
import { GiStoneThrone } from 'react-icons/gi';
// Constants
import { HOME_PAGE_URL } from '../../utils/Constants';
// Nav data
import { getNavLinkItemsArray } from '../../utils/data/NavData';

function Navbar() {
  const navLinkItemsArray = getNavLinkItemsArray();
  const location = useLocation();
  const [isPhoneNavOpen, setIsPhoneNavOpen] = useState(false);

  const togglePhoneNav = () => {
    setIsPhoneNavOpen((prev) => !prev);
  };

  // If path is "/", only show the "Enter" link to /home
  const filteredNavItems =
    location.pathname === '/'
      ? [{ path: HOME_PAGE_URL, label: 'Enter' }]
      : navLinkItemsArray;

  return (
    <nav
      role='navigation'
      aria-label='Main Navigation'
      className='relative border-b-8 border-solid border-colour7 h-fit py-4 lg:py-6'
    >
      <section className='grid grid-cols-reg px-4 md:px-8'>
        <section className='grid items-center justify-center'>
          <NavLink
            to={HOME_PAGE_URL}
            className={`grid grid-flow-col gap-2 items-center`}
          >
            <div>
              <p className='font-titleFont tracking-widest text-xl lg:text-2xl font text-colour1'>
                <span>Liyah</span>
                <span className='text-colour7 pl-1'>Minx</span>
              </p>
            </div>
          </NavLink>
        </section>

        <section className='grid justify-end'>
          {/* Mobile screen */}
          <button
            aria-label='Toggle navigation menu'
            onClick={togglePhoneNav}
            className='grid lg:hidden w-fit h-fit items-center justify-center text-3xl text-colour1 cursor-pointer'
          >
            <IoMdMenu className='active:scale-90 duration-300' />
          </button>

          {/* Large screen */}
          <ul className='hidden lg:grid grid-flow-col gap-6 items-center text-colour1 '>
            {filteredNavItems.map(({ path, label }) => (
              <NavItem key={label} url={path} title={label} />
            ))}
          </ul>
        </section>
      </section>

      {/* Phone navbar */}
      <section
        className={`phone-nav absolute top-full w-full bg-colour2 transition-transform duration-300 ${
          isPhoneNavOpen
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <ul className='grid gap-8 items-center justify-center text-center text-colour1 py-10 border-b-2 border-t-2 border-solid border-colour7'>
          {filteredNavItems.map(({ path, label }) => (
            <NavItem key={label} url={path} title={label} />
          ))}
        </ul>
      </section>
    </nav>
  );
}

const NavItem = ({ url, title }) => {
  return (
    <li className='active:scale-90'>
      <NavLink
        to={url}
        aria-label={`${title} page navigation tab`}
        className='text-xl md:text-lg hover:brightness-90 duration-200 active:scale-75'
        aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
        style={({ isActive }) => {
          return isActive ? { color: '#6068bd' } : {};
        }}
      >
        {title}
      </NavLink>
    </li>
  );
};

export default Navbar;
